export default "__VITE_ASSET__7LMagxCP__"